const ONE_DAY_IN_MILLISECONDS = 864e5;

export const isFeedbackOverdue = (givenDate: Date, daysOverdue = 10): boolean => {
  const dueDate = new Date().setHours(0, 0, 0, 0) - daysOverdue * ONE_DAY_IN_MILLISECONDS;
  const currentDate = givenDate.setHours(0, 0, 0, 0);
  return currentDate <= dueDate;
};
